import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6d3e08cf"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home" }
const _hoisted_2 = { class: "home__main" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "home__title" }, "snake", -1))
const _hoisted_4 = /*#__PURE__*/_createTextVNode("play")
const _hoisted_5 = {
  ref: "canvas",
  width: "600",
  height: "600"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_button = _resolveComponent("base-button")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_router_link, {
        to: "/game",
        custom: ""
      }, {
        default: _withCtx(({ navigate, href }) => [
          _createVNode(_component_base_button, {
            onClick: navigate,
            onKeypress: _withKeys(navigate, ["enter"]),
            tag: "a",
            href: href,
            class: "home__button"
          }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 2
          }, 1032, ["onClick", "onKeypress", "href"])
        ]),
        _: 1
      })
    ]),
    _createElementVNode("canvas", _hoisted_5, null, 512)
  ]))
}